import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-up\"><path d=\"M480.1 291.4c-0.8 0.6-1.7 1.4-2.5 2.1L82.7 654c-21.5 19.6-23 52.9-3.4 74.4 19.6 21.5 52.9 23 74.4 3.4l359.8-328.3 358.8 328.6c21.4 19.6 54.7 18.2 74.4-3.3 19.6-21.4 18.2-54.7-3.3-74.4L549.1 293.3c-19.6-18-49.1-18.3-69-1.9z\" fill=\"\" p-id=\"5116\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol